import jQuery from "jquery";
window.jQuery = jQuery;
$ = jQuery;

import "emojionearea";
import "jquery.scrollto";
import socketCluster from "socketcluster-client";
import { crypt } from "./modules/crypt-aes";
import { forceInt } from "./functions";

$(function() {
    const $chatContainer = $("#js-chatContainer"),
        $chatMembers = $("#sasky-chat-members ul"),
        $bannedIps = $("#sasky-chat-banned-ips ul"),
        chatRoom = $chatContainer.data("chatroom") || "",
        nickname = $chatContainer.data("chatnickname") || "",
        isModerator = $chatContainer.data("chatismoderator") === true ? 1 : 0,
        chatEmail = $chatContainer.data("chatemail") || "",
        secure = location.protocol === "https:",
        socketClusterOptions = {
            // hostname: '10.27.10.42', // just for dev
            port: 2083,
            secure: secure,
            autoReconnect: true
        };
    // if (process.env && "NODE_ENV" in process.env && process.env.NODE_ENV === "watch") {
    //     socketClusterOptions.hostname = '10.27.10.42';
    // }
    const socket = socketCluster.connect(socketClusterOptions),
        chatChannel = socket.subscribe(chatRoom);

    chatChannel.watch(function(messageObject) {
        // console.log('messageType', messageObject.messageType);
        if (messageObject.messageType === "members") {
            $chatMembers.empty();

            const members = JSON.parse(crypt.decrypt(messageObject.data));
            // console.log(members);
            if (members.length) {
                members.sort(function(a, b) {
                    // const textA = a.nickname.toUpperCase(),
                    //     textB = b.nickname.toUpperCase();
                    // return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    return a.nickname.localeCompare(b.nickname);
                });
                let member = false;
                for (var n = 0, m = members.length; n < m; n++) {
                    member = members[n];
                    $chatMembers.append('<li class="' + (member.isModerator === 1 ? 'is-moderator ' : '') + (member.banned == 1 ? 'banned' : 'not-banned') + '"><span>' + member.nickname + '</span><a href="#" class="sasky-chat-ban" data-nickname="' + member.nickname + '" data-email="' + member.email + '" data-banned="' + member.banned + '" data-ip="' + member.ip + '">' + (member.banned === 1 ? hpaTranslatedtext.chatModerator.unbanUser : hpaTranslatedtext.chatModerator.banUser) + '</a></li>'); // Unban Ban
                }
            }
        } else if (messageObject.messageType === 'settings') {
            const settings = JSON.parse(crypt.decrypt(messageObject.data));
            if (typeof settings === 'object') {
                // console.log(settings);
                const mode = settings.mode === 1 ? 1 : 0;
                toggleChatModeButtons(mode);
            }
        } else if (messageObject.messageType === 'bannedIps') {
            $bannedIps.empty();
            const bannedIps = JSON.parse(crypt.decrypt(messageObject.data));
            // console.log(bannedIps);
            for (var n = 0, m = bannedIps.length; n < m; n++) {
                const bannedIp = bannedIps[n];
                $bannedIps.append('<li><span>' + bannedIp + '</span><a href="#" class="sasky-chat-remove-bannedIp" data-ip="' + bannedIp + '">Remove</a></li>');
            }
        }
    });

    $('#sasky-chat-members ul').on('click', 'li .sasky-chat-ban', function(e) {
        e.preventDefault();

        const $this = $(this),
            nickname = $this.data('nickname'),
            email = $this.data('email'),
            ip = $this.data('ip'),
            banned = (forceInt($this.data('banned') === 1 ? 0 : 1)); // toggle it

        const confirmMessage = banned ? hpaTranslatedtext.chatModerator.confirmUnbanUser.replace('%s', nickname) : hpaTranslatedtext.chatModerator.confirmBanUser.replace('%s', nickname); // Unban %s? Ban %s?

        if (!confirm(confirmMessage)) return false;

        banUserToggle({ email, chatRoom, banned, ip });
    });

    function banUserToggle(data) {
        socket.emit("ban", data);
    }

    $('.btn-chat-mode').on('click', function(e) {
        e.preventDefault();

        const $this = $(this),
            mode = forceInt($this.data('mode'));

        const confirmMessage = mode ? 'Enable Normal mode?' : 'Enable Moderator Only mode?';
        if (!confirm(confirmMessage)) {
            return false;
        }

        // Don't toggle because we get the settings sent back to us. Toggle it then.
        // toggleChatModeButtons(mode);

        const data = { email: chatEmail, chatRoom, mode };
        socket.emit('settings_mode', data);
        // console.log('emit setting_mode', data);
    });

    function toggleChatModeButtons(mode) {
        if (mode === 1) {
            $('#btn-chat-mode-1').removeClass('btn-default').addClass('btn-success');
            $('#btn-chat-mode-0').removeClass('btn-danger').addClass('btn-default');
        } else if (mode === 0) {
            $('#btn-chat-mode-1').removeClass('btn-success').addClass('btn-default');
            $('#btn-chat-mode-0').removeClass('btn-default').addClass('btn-danger');
        }
    }

    $('#sasky-chat-banned-ips ul').on('click', 'li .sasky-chat-remove-bannedIp', function(e) {
        e.preventDefault();

        const $this = $(this),
            ip = $this.data('ip');

        const confirmMessage = hpaTranslatedtext.chatModerator.confirmUnbanUser.replace('%s', ip);

        if (!confirm(confirmMessage)) return false;

        const data = { email: chatEmail, chatRoom, ip };
        socket.emit('unbanIp', data);
        // console.log('emit setting_mode', data);
    });

});



// WEBPACK FOOTER //
// ./js/chatModerator.js